// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mn-0";
export var discountCodeInput = "_mn-1";